// Massage the inbox item response to make it closer to what the FE expects
export default item => ({
  ...item,
  call: {
    ...item.call,
    caller: {
      id: item.call && item.call.callerId,
      firstName: item.call && item.call.callerFirstName,
      lastName: item.call && item.call.callerLastName,
    },
  },
});
